import { ExperienceGuidePage } from 'data/records'
import { resource, collection, findSelector } from 'data/helpers/apiv3'

const [api, actions] = resource(ExperienceGuidePage, [
  ['list', collection.get('', ['experienceId'])],
  collection.post('reorderNested', ['experienceId', 'orderNested'])
])

const selectors = {
  ...findSelector(ExperienceGuidePage),
  byExperienceId: (state, experienceId) => state.apiv3.experienceGuidePage.id.filter(egp => egp.experienceId),
  childrenForId: (state, id) => state.apiv3.experienceGuidePage.id
    .filter(egp => egp.experienceGuidePageId === id)
    .sortBy(gp => gp.position),
  topGuides: (state, id) => state.apiv3.experienceGuidePage.id
    .filter(egp => (egp.experienceId === id && egp.experienceGuidePageId === null))
    .sortBy(egp => egp.position)
}

const reducers = {}

const initialState = {}

export {
  api as experienceGuidePageApi,
  actions as experienceGuidePageActions,
  selectors as experienceGuidePageSelectors,
  reducers as experienceGuidePageReducers,
  initialState as experienceGuidePageInitialState
}
